import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import appReducer from "./App";
import authReducer from "./Auth";
import actionStatusReducer from "./ActionStatus";
import documentReducer from "./Document";
import progressReducer from "./Progress";
import dealReducer from "./Deal";
import C from "../../js/constants";

const allReducers = appReducer(
  combineReducers({
    auth: authReducer,
    documents: documentReducer,
    actionStatus: actionStatusReducer,
    progress: progressReducer,
    deals: dealReducer,
    routing: routerReducer,
  })
);

const rootReducer = (state, action) => {
  if (action.type === C.RESET_STORE) {
    state = undefined;
  }

  return allReducers(state, action);
};

export default rootReducer;
